import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, FormikActions } from 'formik';
import { required } from 'utils/formValidators';
import TextField from 'components/TextField';

// import { IRootState } from 'reducers';
import { Actions as userActions } from 'reducers/user';
import { Actions as appActions } from 'reducers/app';

interface IValues {
  login: string;
  password: string;
}

interface IProps {
  login: any;
}

const LoginPage: React.SFC<IProps> = ({
  login,
}) => {
  const [isPasswordVisible, toggleVisible] = useState(false);

  const submit = (values: IValues, { setSubmitting, setStatus }: FormikActions<IValues>) => {
    login(values, setStatus, setSubmitting);
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={{
          login: '',
          password: '',
        }}
        onSubmit={submit}
        // validate={formValidate}
        render={({ errors, touched, isValidating, isSubmitting, submitForm, handleReset, status }) => (
          <div className="container">
            <div className="entry text-center m-auto">
              <h2 className="entry__title">Вход</h2>
              <Form>
                <div style={{ height: '25px', textAlign: 'center', lineHeight: '16px' }}>
                  {status && !isSubmitting && <span className="invalid">{status}</span>}
                </div>
                <div className="form-group text-left">
                  <label htmlFor="input1">Логин</label>
                  <Field
                    id="input1"
                    name="login"
                    placeholder="Логин"
                    component={TextField}
                    validate={required}
                  />
                </div>
                <div className="form-group text-left rel">
                  <label htmlFor="input2">Пароль</label>
                  <Field
                    id="input2"
                    name="password"
                    placeholder="Пароль"
                    type={isPasswordVisible ? 'text' : 'password'}
                    component={TextField}
                    validate={required}
                  />
                  <div onClick={() => toggleVisible(!isPasswordVisible)} className="icon__pass" title={`${isPasswordVisible ? 'Скрыть' : 'Показать'} пароль`}>
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0)">
                        <path d="M25.7137 7.58289L25.7137 7.58293C25.8954 7.8313 25.8954 8.16883 25.7137 8.41752C25.6008 8.57181 24.1675 10.5056 21.885 12.3995C19.5996 14.2959 16.4825 16.1358 12.9999 16.1358C9.51721 16.1358 6.40013 14.2959 4.11461 12.3995C1.83176 10.5053 0.398467 8.57116 0.286129 8.41732C0.104616 8.16856 0.104624 7.83123 0.286154 7.58248C0.399025 7.42807 1.83221 5.49442 4.11461 3.60061C6.40013 1.7042 9.51721 -0.135645 12.9999 -0.135645C16.4825 -0.135645 19.5996 1.7042 21.885 3.60064C24.1679 5.49486 25.6012 7.42897 25.7137 7.58289ZM1.83315 7.90419L1.75467 7.99959L1.83325 8.0949C2.50476 8.90941 3.97465 10.5625 5.93328 12.0132C7.88985 13.4624 10.3503 14.7215 12.9999 14.7215C15.655 14.7215 18.1158 13.4631 20.0713 12.0143C22.0288 10.5641 23.4959 8.91117 24.1666 8.09595L24.2451 8.00056L24.1665 7.90524C23.4947 7.0903 22.0248 5.43716 20.0662 3.98659C18.1096 2.53754 15.6493 1.27863 12.9999 1.27863C10.3448 1.27863 7.88391 2.53706 5.92842 3.98581C3.97093 5.43605 2.50381 7.08894 1.83315 7.90419Z" fill="#8294A6" stroke="white" strokeWidth="0.3" />
                        <path d="M8.00742 7.99981C8.00742 5.24692 10.2474 3.00693 13.0003 3.00693C15.7532 3.00693 17.9932 5.24692 17.9932 7.99981C17.9932 10.7527 15.7532 12.9927 13.0003 12.9927C10.2474 12.9927 8.00742 10.7527 8.00742 7.99981ZM9.42175 7.99981C9.42175 9.97319 11.0269 11.5784 13.0003 11.5784C14.9737 11.5784 16.5789 9.97319 16.5789 7.99981C16.5789 6.02643 14.9737 4.42126 13.0003 4.42126C11.0269 4.42126 9.42175 6.02643 9.42175 7.99981Z" fill="#8294A6" stroke="white" strokeWidth="0.3" />
                        {isPasswordVisible && <line x1="24.3452" y1="-2.63832" x2="2.34524" y2="18.3617" stroke="#8294A6" />}
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="26" height="26" fill="white" transform="matrix(-1 0 0 1 26 0)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div className="form-group mb-0">
                  <button type="submit" disabled={isSubmitting} className="btn">Войти</button>
                  <Link to="/auth/recovery" className="reg__clean">Забыли пароль?</Link>
                </div>
              </Form>
            </div>
          </div>
        )}
      />
    </React.Fragment>
  );
};

const actions = {
  login: userActions.performLogin,
};

export default connect(null, actions)(LoginPage);
